module.exports = __webpack_public_path__ + "static/media/05-img-02@3x.ae5cb809.webp";